import { render, staticRenderFns } from "./SettingRoundModal.vue?vue&type=template&id=0cb0bedb&"
import script from "./SettingRoundModal.vue?vue&type=script&lang=js&"
export * from "./SettingRoundModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports